import { useNavigate } from 'react-router-dom';
import { T } from '@design/index';
import { govPageContainer, GOV_TYPE } from '../ui/PatientUIGovernor';

const LEGAL_ITEMS = [
  { icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z M14 2v6h6', label: 'Terms of Service', route: '/patient/legal/terms', color: T.navy },
  { icon: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z', label: 'Privacy Policy', route: '/patient/legal/privacy', color: T.teal },
  { icon: 'M22 12h-4l-3 9L9 3l-3 9H2', label: 'Medical Disclaimer', route: '/patient/legal/medical-disclaimer', color: '#EF4444' },
  { icon: 'M9 11l3 3L22 4 M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11', label: 'Consent Policy', route: '/patient/legal/consent-policy', color: T.success },
  { icon: 'M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9 M13.73 21a2 2 0 01-3.46 0', label: 'Emergency Access Policy', route: '/patient/legal/emergency-access', color: T.warning },
  { icon: 'M12 2a10 10 0 100 20 10 10 0 000-20z M12 8v4l3 3', label: 'AI Safety & Usage', route: '/patient/legal/ai-safety', color: '#8B5CF6' },
  { icon: 'M15.05 5A5 5 0 0119 8.95M15.05 1A9 9 0 0123 8.94M2 16.1A5 5 0 015.95 12M2 12.05A9 9 0 015.95 8', label: 'Telemedicine Policy', route: '/patient/legal/telemedicine', color: T.info },
  { icon: 'M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4 M17 8l-5-5-5 5 M12 3v12', label: 'Data Retention & Deletion', route: '/patient/legal/data-retention', color: '#F59E0B' },
  { icon: 'M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10', label: 'About NeoHealthCard', route: '/patient/legal/company', color: T.navy },
];

export default function PatientLegalCenter() {
  const navigate = useNavigate();

  return (
    <div style={{ ...govPageContainer(), display: 'flex', flexDirection: 'column', gap: 14 }}>

      <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 16, padding: 16, boxShadow: T.shadow }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: `${T.navy}10`, display: 'grid', placeItems: 'center' }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke={T.navy} strokeWidth="2" strokeLinecap="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
          </div>
          <div>
            <div style={{ ...GOV_TYPE.pageTitle }}>Legal & Health Safety</div>
            <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font }}>Policies, disclaimers, and safety information</div>
          </div>
        </div>
      </div>

      <div style={{ background: T.white, border: `1px solid ${T.border}`, borderRadius: 16, overflow: 'hidden', boxShadow: T.shadow }}>
        {LEGAL_ITEMS.map((item, i) => (
          <button
            key={item.route}
            onClick={() => navigate(item.route)}
            style={{
              width: '100%', display: 'flex', alignItems: 'center', gap: 12,
              padding: '13px 16px', border: 'none', background: 'transparent', cursor: 'pointer',
              borderBottom: i < LEGAL_ITEMS.length - 1 ? `1px solid ${T.border}` : 'none',
              textAlign: 'left',
            }}
          >
            <div style={{ width: 32, height: 32, borderRadius: 8, background: `${item.color}10`, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke={item.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={item.icon} /></svg>
            </div>
            <div style={{ flex: 1, fontSize: 11, fontWeight: 600, color: T.text, fontFamily: T.font }}>{item.label}</div>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.textTer} strokeWidth="2" strokeLinecap="round"><path d="M9 18l6-6-6-6" /></svg>
          </button>
        ))}
      </div>

      <div style={{ background: `${T.info}08`, border: `1px solid ${T.info}20`, borderRadius: 12, padding: 12 }}>
        <div style={{ fontSize: 9, color: T.textSec, fontFamily: T.font, lineHeight: 1.6 }}>
          NeoHealthCard is a digital health infrastructure platform. All policies are subject to applicable local laws and regulations. For questions, contact support@neohealthcard.com.
        </div>
      </div>
    </div>
  );
}
